import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiTwitter, FiGithub, FiLinkedin } from 'react-icons/fi';
import AnimatedLogo from './AnimatedLogo';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    imageTools: [
      { label: 'Image Converter', path: '/image-converter' },
      { label: 'Image Compressor', path: '/image-compressor' },
      { label: 'Image Cropper', path: '/image-cropper' },
      { label: 'Base64 Converter', path: '/base64-converter' }
    ],
    pdfTools: [
      { label: 'Merge PDF', path: '/pdf-merge' },
      { label: 'Split PDF', path: '/pdf-split' },
      { label: 'PDF to Images', path: '/pdf-to-images' },
      { label: 'Compress PDF', path: '/compress-pdf' },
      { label: 'Add Watermark', path: '/pdf-watermark' }
    ],
    videoTools: [
      { label: 'Video to GIF', path: '/video-to-gif' },
      { label: 'Video to Audio', path: '/video-to-audio' },
      { label: 'Remove Audio', path: '/video-audio-remover' },
      { label: 'Compress Video', path: '/video-compressor' }
    ]
  };

  const socialLinks = [
    { icon: <FiTwitter />, url: '#', label: 'Twitter' },
    { icon: <FiGithub />, url: '#', label: 'GitHub' },
    { icon: <FiLinkedin />, url: '#', label: 'LinkedIn' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <AnimatedLogo size={48} />
              <span className="logo-text">
                <span className="logo-text-white">Multiverse</span>
                <span className="logo-text-gradient">Tools</span>
              </span>
            </div>
            <p className="footer-description">
              Convert, compress, crop, and edit your files instantly. No signup, no software, no watermarks — just fast, free tools that work right in your browser.
            </p>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  className="social-link"
                  whileHover={{ scale: 1.1, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label={social.label}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </div>

          <div className="footer-links-grid">
            <div className="footer-links-column">
              <h4 className="footer-heading">IMAGE TOOLS</h4>
              <ul className="footer-links-list">
                {footerLinks.imageTools.map((link, index) => (
                  <motion.li 
                    key={index}
                    whileHover={{ x: 5 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                  >
                    <Link to={link.path}>{link.label}</Link>
                  </motion.li>
                ))}
              </ul>
            </div>

            <div className="footer-links-column">
              <h4 className="footer-heading">PDF TOOLS</h4>
              <ul className="footer-links-list">
                {footerLinks.pdfTools.map((link, index) => (
                  <motion.li 
                    key={index}
                    whileHover={{ x: 5 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                  >
                    <Link to={link.path}>{link.label}</Link>
                  </motion.li>
                ))}
              </ul>
            </div>

            <div className="footer-links-column">
              <h4 className="footer-heading">VIDEO TOOLS</h4>
              <ul className="footer-links-list">
                {footerLinks.videoTools.map((link, index) => (
                  <motion.li 
                    key={index}
                    whileHover={{ x: 5 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                  >
                    <Link to={link.path}>{link.label}</Link>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} Multiverse Tools. All rights reserved.
          </p>
          <p className="tagline">
            Free Online Tools for Everyone
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
